<div>
  <nz-form-item [hidden]="actionType === 'View'">
    <nz-form-control nzHasFeedback nzErrorTip="Input is required">
      <nz-input-group [hidden]="!section.AdditionalInformationParsed.AllowScan" [nzPrefix]="scanIcon"
        [nzSuffix]="scanClear1" [nzAddOnAfter]="switchIcon" nzSize="large">
        <input nz-input [disabled]="recordModel.ObjectKey === 'ITM_OFF_LOAD_DEF'" required #scanControl type="text" name="barcode" autocomplete="off"
          [placeholder]="scanFieldPlaceholder | locale"
          (change)="executeScan(scanControl, quantityControl, serialNumberControl)" style="padding-left: 5px;" />
      </nz-input-group>
      <nz-input-group
        [ngClass]="{ 'hidden': rowToWorkWith == null || rowToWorkWith === undefined || !batchScanFieldVisible }"
        [hidden]="!section.AdditionalInformationParsed.AllowScan" [nzPrefix]="scanIcon" [nzSuffix]="scanClear"
        nzSize="large">
        <input nz-input required #scanBatchControl type="text" name="batch" autocomplete="off"
          [disabled]="isModalOpen"
          [placeholder]="'Scan batch here' | locale"
          (change)="executeScanOfBatchAfterItem(scanBatchControl, quantityControl)" style="padding-left: 5px;" />
      </nz-input-group>
      <nz-input-group
        [ngClass]="{ 'hidden': rowToWorkWith == null || rowToWorkWith === undefined || !binScanFieldVisible }"
        [hidden]="!section.AdditionalInformationParsed.AllowScan" [nzPrefix]="scanIcon" [nzSuffix]="scanClear"
        nzSize="large">
        <input nz-input required #scanBinControl type="text" name="batch" autocomplete="off"
          [placeholder]="'Scan bin here' | locale"
          (change)="executeScanOfBinAfterBatch(scanBatchControl,scanBinControl,quantityControl)"
          style="padding-left: 5px;" />
      </nz-input-group>
      <!--off loading controls-->
      <nz-input-group [ngClass]="{ 'hidden': !offLoadingItemScanFieldVisible }"
        [hidden]="!section.AdditionalInformationParsed.AllowScan" [nzPrefix]="scanIcon" [nzSuffix]="scanClear"
        nzSize="large">
        <input nz-input required #scanOffLoadingItemControl type="text" name="off_item_barcode" autocomplete="off"
          [placeholder]="'Scan Item/barcode here' | locale"
          (change)="executeScanOffLoadingItem(scanOffLoadingItemControl)" style="padding-left: 5px;" />
      </nz-input-group>
      <nz-form-item [ngClass]="{ 'hidden': !offLoadingUOMScanFieldVisible }">
        <nz-form-control>
          <nz-input-group nzSize="large">
            <nz-select #scanOffLoadingUOMControl nzShowSearch [(ngModel)]="offLoadingUOM"
              (keydown)="executeScanOffLoadingUOM(scanControl,offloadQuantityControl, $event)"
              (ngModelChange)="executeScanOffLoadingUOMChange(scanControl, offloadQuantityControl)"
              [nzPlaceHolder]="'UOM' | locale" style="width: 100%">
              <ng-container *ngFor="let option of offLoadingUOMOptions">
                <nz-option [nzValue]="option.Code.toString()" [nzLabel]="option.Name"></nz-option>
              </ng-container>
            </nz-select>
          </nz-input-group>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item [ngClass]="{ 'hidden': !offLoadingQtyScanFieldVisible }">
        <nz-form-control class="quantity-main-input">
          <nz-input-group nzSize="large">
            <nz-input-number #offloadQuantityControl required name="scanned-qty" name="offloadQuantityControl"
              [nzParser]="numberParser" (keydown)="offloadQuantityScanned(scanOffLoadingItemControl.value,
              scanControl, offloadQuantityControl, $event)"
              (nzBlur)="offloadQuantityScannedBlur(scanControl,scanOffLoadingItemControl, offloadQuantityControl)"
              [(ngModel)]="scannedQty" [nzPlaceHolder]="'Quantity' | locale">
            </nz-input-number>
          </nz-input-group>
        </nz-form-control>
      </nz-form-item>
      <!--off loading controls-->

      <nz-alert [nzMessage]="sectionTotals()" nzType="info"> </nz-alert>
      <nz-alert *ngIf="lastScannedLineInfoVisible" [nzMessage]="msgTpl" nzType="warning">
        <ng-template #msgTpl>
          <span [innerHTML]="lastScannedLineInfo()"></span>
        </ng-template>
      </nz-alert>
      <ng-template #switchIcon>
        <nz-space>
          <!-- <nz-space-item *ngIf="shouldFocusOnScanControl && this.moduleStructure.module.Id === shouldFocusOnScanControlModuleId">
            <a nz-button (click)="shouldFocusOnScanControl = false;">{{'Stop scan' | locale}}</a>
          </nz-space-item> -->
          <nz-space-item *ngIf="recordModel.ObjectKey === 'ITM_OFF_LOAD_DEF'">
            <a nz-button (click)="ScanNewOffLoadingPallet()">{{'New Pallet' | locale}}</a>
          </nz-space-item>
          <nz-space-item *ngIf="recordModel.ObjectKey === 'ITM_OFF_LOAD_DEF'">
            <a nz-button (click)="FinishScanOffLoadingPallet(scanControl, quantityControl)">{{'Finish Pallet' | locale}}</a>
          </nz-space-item>
          <nz-space-item *ngIf="recordModel.ObjectKey !== 'ITM_OFF_LOAD_DEF'">
            <nz-switch *ngIf="enableReverseMode" [(ngModel)]="isReverse" [nzCheckedChildren]="'Reverse' | locale"
              [nzUnCheckedChildren]="'Forward' | locale"></nz-switch>
          </nz-space-item>
          <nz-space-item *ngIf="recordModel.ObjectKey !== 'ITM_OFF_LOAD_DEF'">
            <nz-switch *ngIf="enableAutoIncreaseMode" [(ngModel)]="autoIncrease" [nzCheckedChildren]="'Auto' | locale"
              [nzUnCheckedChildren]="'Manual' | locale"></nz-switch>
          </nz-space-item>
          <nz-space-item *ngIf="screenSize === 'large' || screenSize === 'medium' || screenSize === 'x-large'">
            <nz-switch [(ngModel)]="displayMode" [nzCheckedChildren]="'Cards' | locale"
              [nzUnCheckedChildren]="'Table' | locale"></nz-switch>
          </nz-space-item>
        </nz-space>
      </ng-template>
      <ng-template #scanClear>
        <i *ngIf="scanControl.value !== ''" nz-icon class="ant-input-clear-icon" nzTheme="fill" nzType="close-circle"
          (click)="resetScanAndNew(scanControl)"></i>
      </ng-template>
      <ng-template #scanClear1>
        <i *ngIf="scanControl.value !== ''" nz-icon class="ant-input-clear-icon" nzTheme="fill" nzType="close-circle"
          (click)="resetScan(scanControl)"></i>
      </ng-template>
      <ng-template #scanIcon>
        <i nz-icon nzType="barcode" nzTheme="outline"></i>
      </ng-template>
    </nz-form-control>
  </nz-form-item>
  <div [ngClass]="{ 'hidden': rowToWorkWith == null || rowToWorkWith === undefined }">
    <nz-form-item
      *ngIf="moduleStructure !== undefined && moduleStructure.module.ObjectType !== 'InventoryCounting' && (rowToWorkWith != undefined && (rowToWorkWith['ManBtchNum'] == 'Y' || rowToWorkWith['ManSerNum'] == 'Y') )">
      <nz-form-control *ngIf="this.itemCodeToWorkWith !== undefined">
        <nz-input-group nzSize="large">
          <input nz-input [ngModel]="this.itemCodeToWorkWith.ValueAsObject + ' - SSCC Av.Qty: ' + batchNumberAvaQty"
            readonly />
        </nz-input-group>
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-control *ngIf="this.itemDescriptionToWorkWith !== undefined">
        <nz-input-group nzSize="large">
          <input nz-input [ngModel]="this.itemDescriptionToWorkWith.ValueAsObject" readonly />
        </nz-input-group>
      </nz-form-control>
    </nz-form-item>
    <nz-form-item *ngIf="moduleStructure !== undefined && moduleStructure.module.ObjectType !== 'InventoryCounting'">
      <nz-form-control
        *ngIf="this.openQuantityToWorkWith !== undefined && this.quantityToWorkWith !== undefined && this.quantityToWorkWith !== null">
        <nz-input-group nzSize="large" [nzPrefix]="'Open Qty' | locale">
          <input nz-input
            [ngModel]="this.openQuantityToWorkWith.ValueAsObject + ' - ' + 'Scanned Qty ' + this.quantityToWorkWith.ValueAsObject"
            readonly />
        </nz-input-group>
      </nz-form-control>
    </nz-form-item>

    <nz-form-item
      [ngClass]="{ 'hidden': rowToWorkWith == null || rowToWorkWith === undefined || rowToWorkWith['FromBinActivate'] == null || rowToWorkWith['FromBinActivate'] === undefined || rowToWorkWith['FromBinActivate'] === '' || rowToWorkWith['FromBinActivate'] === 'N' }">
      <nz-form-control>
        <nz-input-group nzSize="large">
          <nz-select #binLocationFrom nzShowSearch [(ngModel)]="fromBinCode"
            (keydown)="fromBinSelected(scanControl,quantityControl, $event)"
            [nzPlaceHolder]="'From Bin Location' | locale" style="width: 100%">
            <ng-container *ngFor="let option of fromBinOptions">
              <nz-option [nzValue]="option.Code.toString()" [nzLabel]="option.Name"></nz-option>
            </ng-container>
          </nz-select>
        </nz-input-group>
      </nz-form-control>
    </nz-form-item>
    <nz-form-item
      [ngClass]="{ 'hidden': rowToWorkWith == null || rowToWorkWith === undefined || rowToWorkWith['BinActivate'] == null || rowToWorkWith['BinActivate'] == null || rowToWorkWith['BinActivate'] === undefined || rowToWorkWith['BinActivate'] === '' || rowToWorkWith['BinActivate'] === 'N' || recordModel.ObjectKey === 'oStockTransfer' }">
      <nz-form-control>
        <nz-input-group nzSize="large">
          <nz-select #binLocationTo nzShowSearch (ngModelChange)="toBinSelected(scanControl,quantityControl)"
            [(ngModel)]="binCode" [nzPlaceHolder]="'Bin Location' | locale" style="width: 100%">
            <ng-container *ngFor="let option of binOptions">
              <nz-option [nzValue]="option.Code.toString()" [nzLabel]="option.Name"></nz-option>
            </ng-container>
          </nz-select>
        </nz-input-group>
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-control class="quantity-main-input">
        <nz-input-group nzSize="large">
          <nz-input-number #quantityControl required name="scanned-qty" name="quantity" [nzParser]="numberParser"
            (keydown)="quantityScanned(scanControl.value,scanControl, quantityControl, $event)"
            (nzBlur)="quantityScannedBlur(scanControl, quantityControl)" [(ngModel)]="scannedQty"
            [nzPlaceHolder]="'Quantity' | locale">
          </nz-input-number>
        </nz-input-group>
      </nz-form-control>
    </nz-form-item>
    <nz-form-item
      [ngClass]="{ 'hidden': rowToWorkWith == null || rowToWorkWith === undefined || rowToWorkWith['BinActivate'] === undefined || rowToWorkWith['BinActivate'] === '' || rowToWorkWith['BinActivate'] === 'N' || recordModel.ObjectKey !== 'oStockTransfer' }">
      <nz-form-control>
        <nz-input-group nzSize="large">
          <nz-select #binLocationToS nzShowSearch (ngModelChange)="toBinSelected(scanControl,quantityControl)"
            [(ngModel)]="binCode" [nzPlaceHolder]="'To Bin Location' | locale" style="width: 100%">
            <ng-container *ngFor="let option of binOptions">
              <nz-option [nzValue]="option.Code.toString()" [nzLabel]="option.Name"></nz-option>
            </ng-container>
          </nz-select>
        </nz-input-group>
      </nz-form-control>
    </nz-form-item>
  </div>
  <nz-form-item
    [ngClass]="{ 'hidden':
    rowToWorkWith == null ||
    rowToWorkWith === undefined ||
    rowToWorkWith['ManBtchNum'] === 'N' ||
    (scanMode === 'Batch' && moduleStructure.module.AdditionalInformationParsed.InventoryDirection === InventoryDirection.Outbound) }">
    <nz-form-control>
      <button nz-button nzType="primary" nzBlock (click)="makeBatchDetailDrawerVisible(quantityToWorkWith)">{{ 'Batch
        details' |
        locale }}</button>
    </nz-form-control>
  </nz-form-item>

  <nz-form-item
    [ngClass]="{ 'hidden': rowToWorkWith == null || rowToWorkWith === undefined || rowToWorkWith['ManSerNum'] === 'N' }">
    <nz-form-control>
      <nz-input-group nzSize="large">
        <input #serialNumberControl nz-input required name="serialNumber" type="text" [(ngModel)]="serialNumber"
          (change)="setSerialNumber(scanControl.value,scanControl);" [placeholder]="'Serial Number' | locale" />
      </nz-input-group>
    </nz-form-control>
  </nz-form-item>
  <ng-container
    *ngIf="(additionalInformation.LineTemplate != null && additionalInformation.LineTemplate !== '') && (displayMode || !(screenSize === 'large' || screenSize === 'medium' || screenSize === 'x-large'))">
    <ng-container *ngIf="this.screenSize === 'small' || this.screenSize === 'x-small' || true">
      <nz-row nzGutter="20" *ngIf="lines.length !== 0">
        <nz-col *ngFor="let data of paginatedLines; let j = index;" nzXs="24" nzSm="24" nzMd="12" nzLg="8" nzXl="6">
          <nz-card [nzActions]="
    ( (section.AdditionalInformationParsed.AllowDelete ||
        (section.AdditionalInformationParsed.AllowDeleteForNewLines && data.IsNew)
      ) && !hideDeleteButtonInCardsSection ? [deleteAction] : []
    ).concat(
      !hideDetailsButtonInCardsSection ? [editAction] : []
    )
  " class="card-line section-line-template-details" [hidden]="">
            <span [innerHTML]="data.LineTemplateHtml | safeHtml">
            </span>
            <div *ngIf="quantityField != null">
              <div class="ant-statistic">
                <div class="ant-statistic-content">
                  <ng-container *ngIf="countedField === undefined">
                    <div class="ant-statistic-title">
                      {{quantityField.Label | locale}}
                    </div>
                    <app-field app-field [lineId]="data.Id" [moduleStructure]="moduleStructure" [field]="quantityField"
                      [recordModel]="recordModel" [section]="section" [actionType]="actionType"
                      [scanControl]="scanControl">
                    </app-field>

                    <nz-switch *ngIf="moduleStructure.module.Id === 50026"
                      [nzCheckedChildren]="'UnLoad Quantity' | locale" [nzUnCheckedChildren]="'Load Quantity'| locale"
                      (ngModelChange)="loadQuantity(data.Id,data.LoadQty)" [(ngModel)]="data.LoadQty"></nz-switch>


                  </ng-container>
                  <nz-space style="width: 100%;" *ngIf="countedField !== undefined">
                    <nz-space-item>
                      <div class="ant-statistic-title">
                        {{quantityField.Label | locale}}
                      </div>
                      <app-field app-field [lineId]="data.Id" [moduleStructure]="moduleStructure"
                        [field]="quantityField" [recordModel]="recordModel" [section]="section"
                        [actionType]="actionType" [scanControl]="scanControl">
                      </app-field>
                    </nz-space-item>
                    <nz-space-item *ngIf="countedField !== undefined" style="text-align: center;">
                      <div class="ant-statistic-title">
                        {{'Counted' | locale}}
                      </div>
                      <app-field app-field [lineId]="data.Id" [moduleStructure]="moduleStructure" [field]="countedField"
                        [recordModel]="recordModel" [section]="section" [actionType]="actionType"
                        [scanControl]="scanControl">
                      </app-field>
                    </nz-space-item>
                  </nz-space>
                  <nz-alert
                    *ngIf="data.OpenQtyProp !== undefined && data.QuantityProp !== undefined && data.OpenQtyProp.ValueAsObject !== 0 && data.OpenQtyProp.ValueAsObject !== '' && data.OpenQtyProp.ValueAsObject < data.QuantityProp.ValueAsObject"
                    nzType="error"
                    [nzMessage]="'The selected quantity (' + data.QuantityProp.ValueAsObject + ') exceeds the open quantity: ' + data.OpenQtyProp.ValueAsObject">
                  </nz-alert>
                  <nz-progress
                    *ngIf="data.OpenQtyProp !== undefined && data.QuantityProp !== undefined && data.OpenQtyProp.ValueAsObject != '' && !data.isNew"
                    [nzPercent]="(data.QuantityProp.ValueAsObject / data.OpenQtyProp.ValueAsObject) * 100"
                    [nzFormat]="formatPercent"
                    [nzStatus]="(data.QuantityProp.ValueAsObject / data.OpenQtyProp.ValueAsObject) > 100 ? 'exception' : ((data.QuantityProp.ValueAsObject / data.OpenQtyProp.ValueAsObject) == 100 ? 'success' : 'normal')">
                  </nz-progress>
                </div>
              </div>
            </div>
            <ng-container *ngFor="let field of fieldsToRenderInCard">
              <div class="ant-statistic-title">
                {{field.Label | locale}}
              </div>
              <app-field app-field [lineId]="data.Id" [moduleStructure]="moduleStructure" [field]="field"
                [recordModel]="recordModel" [section]="section" [actionType]="actionType">
              </app-field>
            </ng-container>
            <app-custom-buttons *ngIf="section != null && displayActionForLine" [moduleStructure]="moduleStructure"
              [recordModel]="recordModel" [recordPage]="parentComponent" [forSection]="true" [recordLine]="data"
              [sectionId]="section.Id" [isCardView]="true">
            </app-custom-buttons>
            <ng-template #deleteAction>
              <a nz-popconfirm *ngIf="(section.AdditionalInformationParsed.AllowDelete || (section.AdditionalInformationParsed.AllowDeleteForNewLines &&
      data.IsNew))" [nzPopconfirmTitle]="'Are you sure you want to delete this row?'| locale"
                nzPopconfirmPlacement="bottomLeft" (nzOnConfirm)="deleteRow(data.Id)">
                <i nz-icon nzType="delete" nzTheme="outline"></i> {{ 'Delete' | locale }}
              </a>
            </ng-template>
            <ng-template #editAction>
              <a (click)="editRow(data, true)">
                <i nz-icon nzType="info-circle" nzTheme="outline"></i> {{ 'Details' | locale }}
              </a>
            </ng-template>
            <ng-container *ngIf="data.IsEditModeDrawerInitialized">
              <nz-drawer nzWrapClassName="drawer-size-3x" [nzVisible]="data.IsEditMode" nzClosable="true"
                (nzOnClose)="editRow(data, false);" [nzTitle]="('Row Details' | locale) + ' #' + (j + 1)"
                [nzFooter]="drawerFooter">
                <div nz-row *ngIf="data.IsEditMode">
                  <div nz-col nzXs="24" nzSm="24" nzMd="24"
                    [nzLg]="{ span: getSpanVal(fieldKey), push: getPushVal(fieldKey), pull: getPullVal(fieldKey) }"
                    [nzXl]="{ span: getSpanVal(fieldKey), push: getPushVal(fieldKey), pull: getPullVal(fieldKey) }"
                    *ngFor="let fieldKey of fieldGroupKeys">
                    <div *ngFor="let field of fieldGroups[fieldKey]">
                      <app-field [moduleStructure]="moduleStructure" [field]="field" [recordModel]="recordModel"
                        [section]="section" [lineId]="data.Id" forceLabelVisible="true" [actionType]="actionType">
                      </app-field>
                    </div>
                  </div>
                </div>
              </nz-drawer>
            </ng-container>
            <ng-template #drawerFooter>
              <button nz-button nzType="primary" (click)="data.IsEditMode = false">
                {{'OK' | locale}}
              </button>
            </ng-template>
          </nz-card>
        </nz-col>
      </nz-row>
      <nz-row [hidden]="!enablePaginationInLineSection">
        <nz-pagination [(nzPageIndex)]="currentPage" [nzTotal]="visibleLines.length"
          [nzPageSize]="pageSizeInLineSection" (nzPageIndexChange)="onPageChange($event)">
        </nz-pagination>
      </nz-row>
    </ng-container>
  </ng-container>
  <ng-container
    *ngIf="(additionalInformation.LineTemplate == null || additionalInformation.LineTemplate === '') || !(displayMode || !(screenSize === 'large' || screenSize === 'medium' || screenSize === 'x-large'))">
    <nz-table #sectionTable nzBordered [nzFrontPagination]="enablePaginationInLineSection"
      [nzPageSize]="pageSizeInLineSection" nzSize="small" *ngIf="lines.length !== 0" [nzData]="lines"
      [nzScroll]="{ x: (tableWidth + 50) + 'px' }">
      <thead>
        <tr>
          <th nzWidth="25px" nzLeft>#</th>
          <th nzWidth="25px" nzLeft
            *ngIf="((section.AdditionalInformationParsed.AllowDelete || section.AdditionalInformationParsed.AllowDeleteForNewLines)) && recordModel.EventType !== 3">
          </th>
          <th *ngFor="let field of fieldsToRender; let i = index;" [nzLeft]="i === 0"
            [nzRight]="i === fieldsToRender.length - 1"
            [nzWidth]="field.AdditionalInformationParsed.Width === 0 ? '240px': field.AdditionalInformationParsed.Width + 'px'">
            {{field.Label | locale}}
          </th>
          <th
            [nzWidth]="(section.AdditionalInformationParsed.CustomActionColumnWidth === 0 ? '250' : section.AdditionalInformationParsed.CustomActionColumnWidth) +'px'"
            *ngIf="section != null && displayActionForLine">
            {{'Actions' | locale}}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of sectionTable.data; let j = index;">
          <td nzWidth="25px" nzLeft>
            {{j + 1}}
          </td>
          <td nzWidth="25px" class="actions-cell" nzLeft *ngIf="((section.AdditionalInformationParsed.AllowDelete || (section.AdditionalInformationParsed.AllowDeleteForNewLines &&
      data.IsNew))) && recordModel.EventType !== 3">
            <a nz-popconfirm [nzPopconfirmTitle]="'Are you sure you want to delete this row?'| locale"
              nzPopconfirmPlacement="bottomLeft" (nzOnConfirm)="deleteRow(data.Id)"><i nz-icon nzType="close"
                nzTheme="outline"></i></a>
          </td>
          <td app-field *ngFor="let field of fieldsToRender; let i = index;" [nzLeft]="i === 0"
            [nzRight]="i === fieldsToRender.length - 1" [lineId]="data.Id" [moduleStructure]="moduleStructure"
            [field]="field" [recordModel]="recordModel" [section]="section" [actionType]="actionType">
          </td>
          <td *ngIf="section != null && displayActionForLine">
            <app-custom-buttons [moduleStructure]="moduleStructure" [recordModel]="recordModel"
              [recordPage]="parentComponent" [forSection]="true" [recordLine]="data" [sectionId]="section.Id">
            </app-custom-buttons>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </ng-container>

  <nz-button-group style="margin-top: 20px">
    <button nz-button [nzShape]="'round'" (click)="addLineToTable()" *ngIf="
        section.AdditionalInformationParsed.AllowAdd &&
        (section.AdditionalInformationParsed.AllowAddInEditMode ||
          recordModel.EventType == 0) &&
        actionType != 'View'
      ">
      <i nz-icon nzType="plus" nzTheme="outline"></i> {{ "Add Row" | locale }}
    </button>
  </nz-button-group>
</div>
